// extracted by mini-css-extract-plugin
export var divider = "_rn-0";
export var systemMessage = "_rn-1";